<mat-nav-list>
    <!-- <ng-container *ngIf="currentUserRole === USER_ROLES.user"> -->
    <li routerLinkActive="active">
        <a [ngClass]="'white'" mat-list-item routerLink="/dashboard/users" (click)="catId=null">
            {{'Users list' | translate}}</a>
    </li>
    <!-- <a [ngClass]="'white'" mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/posts">
        {{'Posts' | translate}}</a> -->
    <li routerLinkActive="active">
        <a [ngClass]="'white'" mat-list-item routerLink="/dashboard/sliders" (click)="catId=null">
            {{'Sliders' | translate}}</a>
    </li>
    <li routerLinkActive="active">
        <a [ngClass]="'white'" mat-list-item routerLink="/dashboard/pdf-files" (click)="catId=null">
            {{'Pdf files' | translate}}</a>
    </li>
    <!-- </ng-container> -->

    <br>

    <ng-container *ngFor="let cat of categories">
        <li [class.active]="cat.id && catId === cat.id">
            <a [ngClass]="'white'" mat-list-item (click)="navToCat(cat)">
                {{cat.value}}
            </a>
        </li>
    </ng-container>

    <br>
    <a [ngClass]="'white'" mat-list-item (click)="doLout()">
        {{'Log-out' | translate}}</a>

</mat-nav-list>